<template>
  <el-form label-width="180px"
           label-position="top">
    <HistoryLogCom :fullNode="fullNode"/>

    <div class="evaluation-header">
      <span class="evaluation-title">综合得分</span>
      <span class="evaluation-score">{{ fullNode.project_node.node_result.comprehensive_score }}</span>
      <span class="evaluation-total">(5分)</span>
      <span style="margin-left: 10px;">
        评价人: {{ fullNode.project_node.admin_name || '-' }}丨
        评价时间: {{ fullNode.project_node.node_finished_time || '-' }}
      </span>
    </div>
    <el-form-item label="项目推进的及时性得分"
                  prop="timeliness_score">
      <el-rate v-model="fullNode.project_node.node_result.timeliness_score"
               :max="5"
               disabled
               show-score
               score-template="{value}分">
      </el-rate>
    </el-form-item>

    <el-form-item label="项目报告的准确性得分"
                  prop="report_accuracy_score">
      <el-rate v-model="fullNode.project_node.node_result.report_accuracy_score"
               :max="5"
               disabled
               show-score
               score-template="{value}分">
      </el-rate>
    </el-form-item>

    <el-form-item label="项目客户的满意度得分"
                  prop="customer_satisfaction_score">
      <el-rate v-model="fullNode.project_node.node_result.customer_satisfaction_score"
               :max="5"
               disabled
               show-score
               score-template="{value}分">
      </el-rate>
    </el-form-item>

    <el-form-item label="评价内容"
                  prop="evaluation_content">
      <div class="evaluation-content-display"
           :class="{ 'is-empty': !fullNode.project_node.node_result.evaluation_content }">
        {{ fullNode.project_node.node_result.evaluation_content || '暂无评价内容' }}
      </div>
    </el-form-item>
  </el-form>
</template>

<script>

import HistoryLogCom from '@views/project/node-views/HistoryLogCom.vue'

export default {
  components: {HistoryLogCom},
  mixins: [],
  props: {
    fullNode: {
      type: Object,
      default: () => {},
    },
    projectId: {
      type: String,
      default: '0',
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  methods: {},
}
</script>
<style lang="scss"
       scoped>
.evaluation-header {
  display: flex;
  align-items: baseline;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #ebeef5;

  .evaluation-title {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-right: 12px;
  }

  .evaluation-score {
    font-size: 24px;
    font-weight: 700;
    color: #ef104b;
    margin-right: 4px;
  }

  .evaluation-total {
    font-size: 14px;
    color: #909399;
  }
}

/* 增大评分星星 */
/deep/ .el-rate__icon {
  font-size: 24px;
}

/deep/ .el-rate__text {
  font-size: 16px;
}

.evaluation-content-display {
  padding: 12px 16px;
  background-color: #f8f9fa;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  color: #303133;
  font-size: 14px;
  line-height: 1.6;
  white-space: pre-wrap;
  word-break: break-all;
  min-height: 120px;
  box-sizing: border-box;

  &.is-empty {
    color: #c0c4cc;
    font-style: italic;
  }
}

/deep/ .el-form-item {
  margin-bottom: 12px;
}
/deep/ .el-form-item__label {
  padding-bottom: 4px;
  line-height: 1.4;
}
/deep/ .el-rate__icon {
  font-size: 24px;
}
/deep/ .el-rate__text {
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/project/node-views/BoHeadEvaluationView.vue